import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useAuth } from 'src/contexts/auth'
import { Button, Divider, Input } from 'src/components'
import { useUpdateLot } from 'src/hooks/api/lot/mutations/useUpadeLote'
import { useStyles } from './styles'
import { LotDto } from 'src/dto/lot.dto'
import { Lot, LotParams } from 'src/domain/lot'
import { VALIDATIONS } from 'src/@types/validations'

interface UpdatePropertiesProps {
  onClose: () => void
  data: LotDto | null
}

const UpdateLot: React.FC<UpdatePropertiesProps> = ({ data, onClose }) => {
  const style = useStyles()
  const { userFarm: farmId } = useAuth()
  const { mutateAsync: updateLote, isPending } = useUpdateLot()

  const {
    setValue,
    clearErrors,
    watch,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<LotParams>({
    resolver: yupResolver(VALIDATIONS.Lot),
    defaultValues: {
      descricao: '',
      regime: '',
      idFazenda: farmId!,
      idLote: data?.idLote || ''
    }
  })

  const onFocus = () => {
    const input = document.getElementById('updateLot')
    input?.focus()
  }

  const onSubmit = handleSubmit(async (data: LotParams) => {
    const lotData = new Lot(data)
    await updateLote(lotData)
    onClose()
  })

  useEffect(() => {
    if (data) {
      reset(data)
    }
    onFocus()
  }, [])

  return (
    <>
      <div className={style.updateLotContainer}>
        <Input
          id='updateLot'
          label='Nome do Lote'
          placeholder='Nome do Lote'
          value={watch('descricao')}
          error={errors?.descricao?.message}
          className={style.updateLotInput}
          onChange={(value: string) => {
            setValue('descricao', value)
            clearErrors('descricao')
          }}
        />
        <Input
          label='Regime Alimentar'
          value={watch('regime')}
          placeholder='Ex. Ração'
          error={errors?.regime?.message}
          className={style.updateLotInput}
          onPressEnter={onSubmit}
          onChange={(value: string) => {
            setValue('regime', value)
            clearErrors('regime')
          }}
        />
        <Divider className={style.updateLotDivider} />
        <div className={style.updateLotButtonContainer}>
          <Button outlined onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={onSubmit} disabled={isPending} isLoading={isPending}>
            Salvar
          </Button>
        </div>
      </div>
    </>
  )
}

export default UpdateLot
